import { IDriversInitialState } from '@types';
import { createSelector } from 'reselect';
import { RootState } from 'store';

const driversSelector = (state: RootState) => state.drivers;

const driversListSelector = createSelector([driversSelector], (drivers: IDriversInitialState) => drivers.driversList);

const driverSelector = createSelector([driversSelector], (drivers: IDriversInitialState) => drivers.driver);

export const driversSel = {
    driversSelector,
    driverSelector,
    driversListSelector,
};
